import cogoToast from "cogo-toast";
import {
  getClientList,
  initializeSubstituteOrder,
  setCartProductCount,
  setClient,
  setOrderCategoryId,
} from "../store/slices/auth-slice";
import config from "../utils/config";

// The client stored in Redux drives every catalog/pricing call (getClientProducts,
// getClientProductCategory, ...) and ProtectedRoute sends to /catalog-type when it is missing.
// Orders and returns are reachable without ever selecting a client (UNRESTRICTED_PATHS), so before
// opening the catalog make sure the client is this customer. contactMechId is optional: an edited
// order keeps the client's ship address, a substitute cart takes it from the original order.
export const ensureOrderClient = ({ dispatch, client, partyId, contactMechId, t, onReady }) => {
  const clientAlreadyMatches =
    client?.partyId === partyId &&
    (!contactMechId || client?.contactMechId === contactMechId);

  if (clientAlreadyMatches) {
    onReady();
    return;
  }

  dispatch(
    getClientList({
      setClients: (list) => {
        const match =
          (contactMechId && list.find((c) => c?.contactMechId === contactMechId)) ||
          list.find((c) => c?.partyId === partyId);

        if (!match) {
          cogoToast.error(t("Unable to find the customer for this order"), {
            position: "top-right",
            hideAfter: 5,
          });
          return;
        }

        dispatch(setClient(match));
        onReady();
      },
    })
  );
};

// Opens a substitute cart for a substitution return and moves to its products.
// The new cart replaces the current one: reset the counters tied to the old cart,
// including the single-category constraint (bound to the original order's category).
export const startSubstituteOrderCart = ({ dispatch, navigate, returnId, orderId }) =>
  dispatch(
    initializeSubstituteOrder({
      data: {
        returnId,
        orderId,
        webSiteId: config.websiteId,
      },
      callback: (payload) => {
        const category = payload?.orderCategory || null;
        dispatch(setCartProductCount(0));
        dispatch(setOrderCategoryId(category));
        navigate(category ? `/products?category=${category}` : "/products");
      },
    })
  );
